import "./style.scss";

import { FC, ReactNode, useEffect, useState } from "react";
import { singlePagesConst } from "@/src/constants/single-pages";
import RedLineForTitle from "../RedLineForTitle/RedLineForTitle";

interface ISinglePage {
  pageId?: string;
}
interface ICurrentObj {
  path: string;
  title: string;
  contentJSX: ReactNode;
  contentSearch: string;
}

const SinglePage: FC<ISinglePage> = ({ pageId }) => {
  const [currentObj, setCurrentObj] = useState<ICurrentObj | null>(null);
  useEffect(() => {
    if (pageId) {
      const matchedPage = singlePagesConst.find((page) => {
        const cleanedPath = page.path.replace(/^\/single-page\//, "").replace(/^\//, "");
        return cleanedPath === pageId;
      });

      if (matchedPage) {
        setCurrentObj(matchedPage);
      }
    }
  }, [pageId]);

  return currentObj ? (
    <div className="single-page container padding-top">
      <RedLineForTitle title={currentObj.title} />
      <div className="single-page-content">{currentObj.contentJSX}</div>
    </div>
  ) : null;
};

export default SinglePage;
